/**
 * realtime-console zod 스키마 — 송신 메시지 검증
 * react-hook-form zodResolver 로 연결
 */
import { z } from 'zod';

/** 채팅 메시지 송신 폼 스키마 */
export const chatMessageSchema = z.object({
  text: z
    .string()
    .min(1, '메시지를 입력하세요')
    .max(1000, '메시지가 너무 깁니다 (최대 1000자)'),
  room: z.string().min(1).default('lobby'),
});

export type ChatMessageFormValues = z.infer<typeof chatMessageSchema>;

/** 토픽 방 선택 스키마 */
export const roomSelectSchema = z.object({
  room: z.enum(['lobby', 'ops']).default('lobby'),
});

export type RoomSelectValues = z.infer<typeof roomSelectSchema>;
